<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">B2b渠道电商</div>
            <div class="banner_line"></div>
            <!-- <div class="banner_title2">打造以业务员为核心的超级业务员管理系统</div> -->
            <div class="banner_text">打通各级经销商间交易流，实现多级经销渠道统一管理， 提高企业经营管理效率</div>
        </div>
        <img src="@/assets/Mobile/images/QcB2BChannel/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">解决行业4大痛点</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcB2BChannel/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">打通厂商/品牌商和下游各级经销渠道交易流，实现各经销渠道明确可控</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcB2BChannel/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme2">
        <div class="sk-mobile-title">
          <div class="title">让客户通过商城自主下单，替代业务员接单，让业务员深度做业务和服务</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcB2BChannel/programme3.png" alt="">
            <div class="content_btn">
                <div class="btn_box" @click="linkTo('QcDistribution')"></div>
            </div>
        </div>
      </div>
      <div class="programme programme3">
        <div class="sk-mobile-title">
          <div class="title" style="color: #ffffff;">通过大数字分析，实时了解客户需求，企业经营决策不再盲目</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcB2BChannel/programme4.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">打通渠道分销全链路交易流程，实现全流程在线化管理，提升交易效率，节约运营成本</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcB2BChannel/programme5.png" alt="">
        </div>
      </div>
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcB2BChannel/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcB2BChannel/case2.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="B2B渠道电商" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="B2B渠道电商" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcB2BChannel,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .content_btn{
    width: 100%;
    height: 35px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .btn_box{
        height: 33px;
        width: 110px;
    }
  }
  .programme1{
    background: #F8F9FB;
  }
  .programme2{
    background: #F3F8F8;
  }
  .programme3{
    background: #202239;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 9px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  